import request from '@/utils/request';

// 首页今日统计
export const todayStatistics = (data: any): any =>
  request({
    url: '/pc/homePage/homePageInfo',
    data: data
  })

// 首页商品统计
export const productSellStatisList = (data: any): any =>
  request({
    url: '/pc/homePage/productSellStatisList',
    data: data
  })

// 联创排名(已审核)
export const lianChuangRankList = (data: any): any =>
  request({
    url: '/pc/homePage/lianChuangRankList',
    data: data
  })


// 联创排名(已审核)
export const providerRankList = (data: any): any =>
  request({
    url: '/pc/homePage/providerRankList',
    data: data
  })

// 供应商排名
export const supplierRank = (data: any): any =>
  request({
    url: '/index/provider/ranklist',
    data: data
  })

// 商品排名
export const productRank = (data: any): any =>
  request({
    url: '/index/product/ranklist',
    data: data
  })

// 联创排名
export const lianchuangRank = (data: any): any =>
  request({
    url: '/index/lcrank',
    data: data
  })

// 销售商品排行
export const getUserProductRankList = (data: any): any =>
  request({
    url: '/pc/product/productSalesRanking',
    data: data
  })

// 商品销量统计
export const getProductSalesStatistics = (data: any): any =>
  request({
    url: '/pc/product/sellStatis',
    data: data
  })

// 商品规格销量统计
export const productspecSellStatis = (data: any): any =>
  request({
    url: '/pc/product/specSellStatis',
    data: data
  })

// 分销员业绩统计
export const GetAgentEarningsList = (data: any): any =>
  request({
    url: '/pc/memberPerformance/statisticsList',
    data: data
  })
// 分销员业绩统计详情-个人业绩、团队业绩
export const memberPerformanceDetailList = (data: any): any =>
  request({
    url: '/pc/memberPerformance/detailList',
    data: data
  })
// 分销员业绩统计详情-接单费
export const memberPerformanceOrderFeeList = (data: any): any =>
  request({
    url: '/pc/memberPerformance/orderFeeList',
    data: data
  })

// 分销员团队业绩
export const getTeamEarningsList = (data: any): any =>
  request({
    url: '/agent/team/earnings',
    data: data
  })

// 奖励业绩统计
export const getRewardEarningList = (data: any): any =>
  request({
    url: '/agent/reward/earnings',
    data: data
  })

//业绩统计
export const performanceStatisticList = (data: any): any =>
  request({
    url: '/pc/performanceStatistic/list',
    data: data
  })

//业绩统计商品分布
export const performanceStatisticproductDistributedList = (data: any): any =>
  request({
    url: '/pc/performanceStatistic/productDistributedList',
    data: data
  })

//业绩统计 商品名称
export const productfilterBoxList = (data: any): any =>
  request({
    url: '/pc/product/filterBoxList',
    data: data
  })
  
//业绩统计-业绩详情
export const performanceStatisticOrderList = (data: any): any =>
  request({
    url: '/pc/performanceStatistic/orderList',
    data: data
  })
//业绩统计-下级出货详情
export const performanceStatisticLowerLevelShipList = (data: any): any =>
  request({
    url: '/pc/performanceStatistic/lowerLevelShipList',
    data: data
  })


  
//利润统计-列表
export const profitStatisticList = (data: any): any =>
  request({
    url: '/pc/profitStatistic/list',
    data: data
  })

//利润统计-详情
export const profitStatisticOrderList = (data: any): any =>
  request({
    url: '/pc/profitStatistic/orderList',
    data: data
  })

  
//利润统计-服务费详情
export const profitStatisticserviceFeeList = (data: any): any =>
request({
  url: '/pc/profitStatistic/serviceFeeList',
  data: data
})


  //客户统计
export const customerOrderStatis = (data: any): any =>
request({
  url: '/pc/member/customerOrderStatis',
  data: data
})
//客户统计-详情
export const customerOrderStatisDetail = (data: any): any =>
request({
  url: '/pc/member/customerOrderStatisDetail',
  data: data
})
//访问数据
export const customerVisitStatis = (data: any): any =>
request({
  url: '/pc/member/customerVisitStatis',
  data: data
})

 //客户订单分布
 export const customerOrderDistributed = (data: any): any =>
 request({
   url: '/pc/member/customerOrderDistributed',
   data: data
 })
 //客户订单分布-详情
 export const customerOrderDistributedDetail = (data: any): any =>
 request({
   url: '/pc/member/customerOrderDistributedDetail',
   data: data
 })


 //商品复团申请记录
 export const productRepeatGroupApplyRecord = (data: any): any =>
 request({
   url: '/pc/product/productRepeatGroupApplyRecord',
   data: data
 })

 //复团
 export const productRepeatGroup = (data: any): any =>
 request({
   url: '/pc/product/productRepeatGroup',
   data: data
 })

 
 //导入线下业绩
 export const memberPerformanceofflinePerformanceImport = (data: any): any =>
 request({
   url: '/pc/memberPerformance/offlinePerformanceImport',
   data: data
 })
 //线下业绩导入记录
 export const memberPerformanceofflinePerformanceImpotRecord = (data: any): any =>
 request({
   url: '/pc/memberPerformance/offlinePerformanceImpotRecord',
   data: data
 })

 //利润总计
 export const profitStatisticprofitStatisticTotal = (data: any): any =>
  request({
    url: '/pc/profitStatistic/profitStatisticTotal',
    data: data
  })


 export const productSellCountAnalysisDailyData = (data: any): any =>
  request({
    url: '/pc/dataStatisProductSellAnalysis/productSellCountAnalysisDailyData',
    data: data
  })
 export const productSellCountAnalysisDailyDataDetail = (data: any): any =>
  request({
    url: '/pc/dataStatisProductSellAnalysis/productSellCountAnalysisDailyDataDetail',
    data: data
  })

 export const productSellCountAnalysisDailyCategoryData = (data: any): any =>
  request({
    url: '/pc/dataStatisProductSellAnalysis/productSellCountAnalysisDailyCategoryData',
    data: data
  })

 export const productSellCountAnalysisDailyCategoryDataDetail = (data: any): any =>
  request({
    url: '/pc/dataStatisProductSellAnalysis/productSellCountAnalysisDailyCategoryDataDetail',
    data: data
  })